<div class="weekly-reports-container">
  <div class="page-header">
    <h2>Rapports Hebdomadaires</h2>
  </div>

  <div *ngIf="isLoading" class="loader">
    <p>Chargement en cours...</p>
  </div>

  <div *ngIf="!isLoading && weeklyReports.length === 0" class="empty-state">
    <p>Aucun rapport hebdomadaire disponible.</p>
  </div>

  <div *ngIf="!isLoading && weeklyReports.length > 0" class="reports-table">
    <div class="table-header">
      <div class="col-name">Nom</div>
      <div class="col-lastname">Prénom</div>
      <div class="col-poste">Type de Poste</div>
      <div class="col-establishment">Etablissement</div>
      <div class="col-service">Service</div>
      <div class="col-week">Semaine</div>
      <div class="col-expand"></div>
    </div>

    <div *ngFor="let report of weeklyReports; let i = index" class="table-body">
      <div
        class="table-row"
        [class.expanded]="isRowExpanded(i)"
        (click)="handleRowClick(report, i)"
      >
        <div class="col-name">{{ report.candidateName }}</div>
        <div class="col-lastname">{{ report.candidatLastName }}</div>
        <div class="col-poste">{{ report.typePoste }}</div>
        <div class="col-establishment">{{ report.establishmentName }}</div>
        <div class="col-service">{{ report.serviceAffectation }}</div>
        <div class="col-week">{{ report.weekPeriod }}</div>
        <div class="col-expand">
          <svg-icon
            class="expand-icon"
            [class.rotate]="isRowExpanded(i)"
            src="assets/icons/chevron-down.svg"
          ></svg-icon>
        </div>
      </div>

      <div *ngIf="isRowExpanded(i)" class="expanded-content">
        <div class="days-container">
          <div *ngFor="let day of report.days" class="day-card">
            <div class="day-header">
              <div class="day-info">
                <span class="day-name">{{ day.dayName }}</span>
                <span class="day-date">{{ day.date }}</span>
              </div>
              <div  *ngIf="day.status != 'FREE'"
                    class="day-status" 
                    [ngClass]="'status-' + day.status.toLowerCase()">
                {{ getStatusLabel(day.status) }}
              </div>
            </div>

            <div class="day-details">
              <div class="detail-row" *ngIf="day.missionTitle">
                <span class="label">Mission:</span>
                <span class="value">{{ day.missionTitle }}</span>
              </div>
              <div class="detail-row" *ngIf="day.totalHours > 0">
                <span class="label">Heures:</span>
                <span class="value">{{ day.totalHours | number: '1.2-2' }}h</span>
              </div>
              <div class="detail-row" *ngIf="!day.missionTitle && day.totalHours === 0">
                <span class="no-mission">Pas de mission ce jour</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
